import { ILogger } from './logger.types';

export function createResponseErrorLogger(logger: ILogger) {
  return async (response: Response, request: Request): Promise<Response> => {
    if (response.ok) return response;

    const requestInfo = {
      method: request.method,
      url: request.url,
      headers: headersToObject(request.headers),
    };

    const responseInfo = {
      status: response.status,
      statusText: response.statusText,
      headers: headersToObject(response.headers),
      body: await tryGetResponseBody(response),
    };

    logger.error(`${response.status} ${response.statusText}`, {
      request: requestInfo,
      response: responseInfo,
    });

    return response;
  };
}

function headersToObject(headers: Headers): Record<string, string> {
  const obj: Record<string, string> = {};
  headers.forEach((value, key) => {
    obj[key] = value;
  });
  return obj;
}

async function tryGetResponseBody(response: Response): Promise<unknown> {
  try {
    // Clone response so body can still be consumed later
    const cloned = response.clone();
    const text = await cloned.text();
    // Try JSON first, fallback to text
    return tryParseJSON(text);
  } catch (error) {
    return new Error('Could not get response body', { cause: error });
  }
}

function tryParseJSON(value: string): unknown {
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
}
